import type { IIconProps } from 'types/icons';
import { useTemplateVariant } from 'hooks/useTemplateVariant';
import { BaseIcon } from 'components/icons/BaseIcon';
import { SetIcon } from 'components/icons/SetIcon';
import { useIconSet } from 'hooks/useIconSet';
import { getIconUrl } from 'helpers/iconRegistry';

import CloseIconDarkUrl from 'assets/images/icons/dark - close.svg';
import CloseIconDark from 'assets/images/icons/dark - close.svg?react';
import CloseIconSimpleFiligreeUrl from 'assets/images/icons/simple filigree - close.svg';
import CloseIconSimpleFiligree from 'assets/images/icons/simple filigree - close.svg?react';
import CloseIconSpringVibesUrl from 'assets/images/icons/spring - close.svg';
import CloseIconSpringVibes from 'assets/images/icons/spring - close.svg?react';
import CloseIconVickyBaumannBohoUrl from 'assets/images/icons/vicky boho - close.svg';
import CloseIconVickyBaumannBoho from 'assets/images/icons/vicky boho - close.svg?react';
import CloseIconVickyBaumannFineartUrl from 'assets/images/icons/vicky fineart - close.svg';
import CloseIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - close.svg?react';

const LegacyCloseIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={CloseIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={CloseIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={CloseIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={CloseIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={CloseIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={CloseIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={CloseIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={CloseIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={CloseIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={CloseIconSimpleFiligree} {...props} />
  })();

export const CloseIcon = (props: IIconProps) => (
  <SetIcon slug="close-x" fallback={LegacyCloseIcon} {...props} />
);

export const useCloseIconUrl = () => {
  const iconSet = useIconSet();

  const legacyUrl = useTemplateVariant({
    classic: CloseIconSimpleFiligreeUrl,
    dark: CloseIconDarkUrl,
    simpleFiligree: CloseIconSimpleFiligreeUrl,
    springVibes: CloseIconSpringVibesUrl,
    vickyBaumannBoho: CloseIconVickyBaumannBohoUrl,
    vickyBaumannFineart: CloseIconVickyBaumannFineartUrl,
    breeze: CloseIconSimpleFiligreeUrl,
    capri: CloseIconSimpleFiligreeUrl,
    rose: CloseIconSimpleFiligreeUrl,
    calm: CloseIconSimpleFiligreeUrl
  });

  return (iconSet && getIconUrl(iconSet, 'close-x')) || legacyUrl;
};
